import { render, staticRenderFns } from "./vip-mock-exam.vue?vue&type=template&id=ccbedee0&scoped=true&"
import script from "./vip-mock-exam.vue?vue&type=script&lang=js&"
export * from "./vip-mock-exam.vue?vue&type=script&lang=js&"
import style0 from "./vip-mock-exam.vue?vue&type=style&index=0&id=ccbedee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbedee0",
  null
  
)

export default component.exports